import React from 'react';
import Bell from '../Icons/Bell';

const CardAlert = ({ children }) => (
  <div className="mh4">
    <div
      className="gray ph3 center br2 flex items-center"
      style={{ fontFamily: 'BrandonText', backgroundColor: '#FDF8E6' }}
    >
      <Bell style={{ borderRadius: '50%', border: '1px solid orange' }} />
      <p className="ml3">{children}</p>
    </div>
  </div>
);

export default CardAlert;



// WEBPACK FOOTER //
// ./src/components/Common/CardAlert.js